
<template>
  <div class="knowledge-equiptype">
    <h2 class="top-title">网关管理</h2>
    <ul class="common-search li-margin">
      <li>
        <span>网关名称: </span>
        <Input
          v-model="dataForm.gatewayName"
          @on-search="(e) => searchInput(e, 'gatewayName')"
          search
          placeholder="请输入"
        />
      </li>
      <li>
        <span>网关序列号: </span>
        <Input
          v-model="dataForm.sn"
          @on-search="(e) => searchInput(e, 'sn')"
          search
          placeholder="请输入"
        />
      </li>
      <!-- <li>
        <span>网关型号: </span>
        <Select
          v-model="dataForm.type"
          @on-change="(e) => changeSel(e, 'type', models)"
          :clearable="true"
          placeholder="全部"
        >
          <Option :key="key" :value="type" v-for="(type, key) in models"
            >{{ type }}
          </Option>
        </Select>
      </li> -->
      <li class="dataPicker">
        <span>激活时间: </span>
        <DatePicker
          @on-change="(e) => changeDate(e, 'date')"
          v-model="dataForm.date"
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="请选择"
          :clearable="false"
        />
      </li>
      <li>
        <span>在线状态: </span>
        <Select
          v-model="dataForm.statu"
          @on-change="(e) => changeSel(e, 'statu', selecs)"
          :clearable="true"
          placeholder="全部"
        >
          <Option :key="type.id" :value="type.id" v-for="type in selecs">{{
            type.value
          }}</Option>
        </Select>
      </li>
      <!-- <li>
        <span>激活状态: </span>
        <Select
          v-model="dataForm.activeStatu"
          @on-change="(e) => changeSel(e, 'activeStatu', activations)"
          :clearable="true"
          placeholder="全部"
        >
          <Option :key="type.id" :value="type.id" v-for="type in activations">{{
            type.value
          }}</Option>
        </Select>
      </li> -->
      <li class="searchItem">
        <Button class="sels-item" @click="resetData">重置</Button>
      </li>
    </ul>

    <!-- selected -->
    <div class="common-selects selected-margin" v-if="selItems.length">
      <span class="tit">已选:</span>
      <span class="sel" v-for="(item, index) in selItems" :key="index"
        >{{ item.val }}
        <Icon @click="delSelItem(item, index)" type="md-close-circle"
      /></span>
    </div>

    <!-- v-if='dataLists.length' -->
    <div class="lists clearfix list-margin">
      <Button
        v-nohasPermi="['m3', 'm4']"
        type="primary"
        id="addgateway"
        v-if="isJh"
        @click="addEquip()"
      >
        <Icon type="md-add" /> 激活网关
      </Button>
      <!-- 列表 -->
      <div class="common-list table-margin">
        <Table
          @on-row-click="rowclickmethd"
          @on-expand-tree="expand"
          class="equipmentTable"
          row-key="id"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <!-- 分页器 -->
      <div class="common-page fr" id="gatway-page" v-if="pageInfo.total">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="
            (page) => {
              this.dkindex = 0;
              this.getLists(page);
            }
          "
          @on-page-size-change="getListsSize"
        >
        </Page>
      </div>
    </div>

    <!-- </Card> -->

    <GateDrawer
      :models="models"
      ref="IndusDrawer"
      :showDrawer="showDrawer"
      :closeDrawer="closeDrawer"
      :dataCenter="dataCenter"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :driverTypeList="dataTypeOption"
    />

    <gateType
      ref="IndustypeDrawer"
      :showtypeDrawer="showtypeDrawer"
      :closeDrawer="closeDrawer"
      :dataCenter="dataCenter"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :dataTypeOption="dataTypeOption"
      :timernum="timernum"
    />
    <chronicleDrawer
      :curItemDetail="curItemDetail"
      :data1="chrodata"
      v-model="chronidShow"
    />
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";
import handleSelItem from "@/mixins/handleSelItem";
import GateDrawer from "./components/gate-drawer.vue";
import gateType from "./components/gateType-drawer.vue";
import sizeData from "@/mixins/sizeData";
import chronicleDrawer from "./components/chronicle-drawer.vue";
import {
  gatewayAllData,
  allDriver,
  olistiePage,
  productexcel,
  configThingModel,
  excelup,
  gatedetalog,
} from "@/api/knowledge/gateway";
import { oilSiteGetList, relatedInfo, sockedDel } from "@/api/business/rhlist";

export default {
  name: "knowledge-equiptype",
  mixins: [handleSelItem, sizeData],
  components: {
    GateDrawer,
    gateType,
    chronicleDrawer,
  },
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
      sockedlist: (state) => state.pub.sockedlist,
    }),
    isJh() {
      let useRole = this.userRole;
      if (useRole.includes("m")) {
        return true;
      } else if (useRole.includes("c1")) {
        return true;
      } else {
        false;
      }
    },
  },
  data() {
    return {
      models: ["LE-A-G041", "LE-A-G051"],
      chronidShow: false,
      dataLists: [],
      selItems: [],
      dataForm: {},
      dkindex: 0,
      chrodata: [],
      pageInfo: {
        size: 10,
        current: 1,
        total: 0,
      },
      userRole: ls.get("userRole"),
      showDrawer: false,
      showtypeDrawer: false,
      curItemDetail: {},
      dataColumn: [
        {
          title: "序号",
          key: "name",
          width: 70,

          render: (h, params) => {
            const item = params.row;
            let pname = item.model;
            return h("span", params.index + 1);
          },
        },
        {
          title: "网关名称",
          width: 200,
          key: "name",
          render: (h, params) => {
            const item = params.row;
            let pname = item.nickName;
            return h("span", pname || "-");
          },
        },
        // {
        //   title: "网关型号",
        //   key: "model",
        //   width: 150,
        //   render: (h, params) => {
        //     const item = params.row;
        //     let pname = item.model;
        //     return h("span", pname || "-");
        //   },
        // },
        {
          title: "网关序列号",
          width: "200",
          key: "sn",

          render: (h, params) => {
            const item = params.row;
            let pname = item.sn;
            return h("span", pname || "-");
          },
        },
        {
          title: "所属客户",
          width: 250,
          key: "customerName",
          render: (h, params) => {
            const item = params.row;
            let pname = item.customerName;
            return h("span", pname || "-");
          },
        },
        // {
        //   title: "IP地址",
        //   key: "ipAddress",
        //   width: 200,

        //   render: (h, params) => {
        //     const item = params.row;
        //     let pname = item.ipAddress;
        //     return h("span", pname || "-");
        //   },
        // },

        {
          title: "在线状态",
          key: "statu",
          width: 100,
          render: (h, params) => {
            const item = params.row;
            let show = [];
            if (item && item.statu === "ONLINE") {
              show = [
                h("div", {
                  style: {
                    marginRight: "6px",
                    background: "#6db400",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    display: "inline-block",
                  },
                }),
                h("span", "在线"),
              ];
            } else {
              show = [
                h("div", {
                  style: {
                    marginRight: "6px",
                    background: "#d8d8d8",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    display: "inline-block",
                  },
                }),
                h("span", "离线"),
              ];
            }
            // let activeStatu = item.activeStatu;
            // if (activeStatu !== "ACTIVED") {
            //   show = "-";
            // }
            return h("div", show);
          },
        },
        // {
        //   title: "激活状态",
        //   key: "activeStatu",
        //   width: 100,

        //   render: (h, params) => {
        //     const item = params.row;
        //     let pname2 = item.activeStatu;

        //     // NOT_ACTIVED:未激活 IN_ACTIVED:激活中 ACTIVED:已激活
        //     let text = "";
        //     if (pname2 == "NOT_ACTIVED") {
        //       text = "未激活";
        //     } else if (pname2 == "IN_ACTIVED") {
        //       text = "激活中";
        //     } else if (pname2 == "ACTIVED") {
        //       text = "已激活";
        //     }

        //     return h("span", text);
        //   },
        // },
        // {
        //   title: "激活时间",
        //   width: 200,
        //   key: "activateStartTime",

        //   render: (h, params) => {
        //     const item = params.row;
        //     let pname = item.activateStartTime;
        //     return h("span", pname || "-");
        //   },
        // },
        {
          title: "创建时间",
          width: 200,
          key: "gmtCreate",

          render: (h, params) => {
            const item = params.row;
            let pname = item.gmtCreate;
            return h("span", pname || "-");
          },
        },
        {
          title: "最新下发点表时间",
          key: "distributionPointBeforeTime",

          width: 200,
          render: (h, params) => {
            const item = params.row;
            let pname = item.distributionPointBeforeTime;
            return h("span", pname || "-");
          },
        },
        // {
        //   title: "关联润滑点",
        //   key: "name",
        //   width: "300",

        //   render: (h, params) => {
        //     const item = params.row;
        //     let pname = item.distributionPointBeforeTime;
        //     let pitem = {
        //       oilSiteName: "-",
        //     };
        //     if (
        //       item.oilSiteGatewayDetailOilSiteVOList &&
        //       item.oilSiteGatewayDetailOilSiteVOList.length > 0
        //     ) {
        //       pitem = item.oilSiteGatewayDetailOilSiteVOList[0];
        //     }

        //     return h("span", pitem.oilSiteName || "-");
        //   },
        // },
        {
          title: "操作",
          key: "address",
          align: "left",
          fixed: "right",
          width: 350,
          className: "action",
          render: (h, params) => {
            const item = params.row;
            let btns = [];
            let dowbo = true;

            if (item.statu === "ONLINE") {
              //这个是已经激活的状态
              btns = btns.concat([
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.editDetailType(this.$c.deepClone(item), "edit");
                      },
                    },
                  },
                  "配置网关"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: dowbo
                      ? {
                          color: "#0c479d", //"#e9aa69",
                          cursor: "pointer",
                        }
                      : {
                          color: "#ccc", //"#e9aa69",
                          cursor: "not-allowed",
                        },
                    on: {
                      click: () => {
                        if (dowbo) {
                          this.dowload(item);
                        }
                      },
                    },
                  },
                  "下载点表"
                ),
              ]);
            } else {
              //这个是未激活的
              btns = btns.concat([
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#ccc", //"#e9aa69",
                      cursor: "not-allowed",
                    },
                    on: {},
                  },
                  "配置网关"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: dowbo
                      ? {
                          color: "#0c479d", //"#e9aa69",
                          cursor: "pointer",
                        }
                      : {
                          color: "#ccc", //"#e9aa69",
                          cursor: "not-allowed",
                        },
                    on: {
                      click: () => {
                        if (dowbo) {
                          this.dowload(item);
                        }
                      },
                    },
                  },
                  "下载点表"
                ),
              ]);
            }
            let style =
              item.statu !== "ONLINE"
                ? {
                    color: "#ccc", //"#e9aa69",
                    cursor: "not-allowed",
                  }
                : {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                  };
            btns.push(
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                  },
                },
                "|"
              ),

              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                  },
                  on: {
                    click: async () => {
                      //  this.navtoproedit(item); 产品表编辑
                      this.curItemDetail = this.$c.deepClone(item);
                      // let { data } = await gatedetalog(item.id);

                      // this.chrodata = data;
                      this.chronidShow = true;
                    },
                  },
                },
                "配置记录"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },

                  style,

                  on: {
                    click: () => {
                      this.delItemWarning(item);
                    },
                  },
                },
                "删除"
              )
            );

            if (
              (this.userRole == "m0" && item.groupAuthorityString == "r") ||
              this.userRole == "c0" ||
              this.userRole == "m3" ||
              this.userRole == "m4"
            ) {
              btns = [
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: dowbo
                      ? {
                          color: "#0c479d", //"#e9aa69",
                          cursor: "pointer",
                        }
                      : {
                          color: "#ccc", //"#e9aa69",
                          cursor: "not-allowed",
                        },
                    on: {
                      click: () => {
                        if (dowbo) {
                          this.dowload(item);
                        }
                      },
                    },
                  },
                  "下载点表"
                ),
                h(
                  "span",
                  {
                    style: {
                      color: "#ddd",
                      margin: "0 10px",
                      verticalAlign: "middle",
                    },
                  },
                  "|"
                ),
                h(
                  "span",
                  {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                    },
                    on: {
                      click: async () => {
                        //  this.navtoproedit(item); 产品表编辑
                        this.curItemDetail = this.$c.deepClone(item);
                        let { data } = await gatedetalog(item.id);

                        this.chrodata = data;
                        this.chronidShow = true;
                      },
                    },
                  },
                  "配置记录"
                ),
              ];
            }

            return h("div", btns);
          },
        },
      ],
      dataTypeOption: [],
      timer: null,
      selecs: [
        //statu
        {
          value: "离线",
          id: "OFFLINE",
        },
        {
          value: "在线",
          id: "ONLINE",
        },
      ],
      activations: [
        // NO_ACTIVED
        {
          value: "已激活",
          id: "ACTIVED",
        },
        {
          value: "未激活",
          id: "NO_ACTIVED",
        },
      ],
      timernum: 0,
      soikobj: {},
    };
  },
  mounted() {
    this.init();
    if (!['c0', 'm3', 'm4'].includes(this.userRole)) {
      this.getAllDriver();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    dowload(row) {
      const {
        url
      } = row;
      if (!url) {
        this.$Message.info("暂无点表下载");
        return false;
      }
      // let itemarr = [...deviceOssList, productOss];

      // let itemarr = [
      //   "https://chjclcz-1259548175.cos.ap-nanjing.myqcloud.com/%E7%BD%91%E5%85%B3002%E4%BA%A7%E5%93%81%20%281%29.xlsx",
      //   "https://chjclcz-1259548175.cos.ap-nanjing.myqcloud.com/%E8%AE%A2%E9%A4%90%E6%9C%8D%E5%8A%A1%E6%A8%A1%E6%9D%BF.xlsx",
      // ];
      // const downloadElements = [];

      // itemarr.forEach((url) => {
        // let downloadElement = document.createElement("a");
        // downloadElement.href = url;
        // document.body.appendChild(downloadElement);
        // downloadElement.click();
        // document.body.removeChild(downloadElement);
        //Access-Control-Allow-Origin
        this.downloadFile(url, new Date());
      // });
    },
    downloadFile(url, filename) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = xhr.response;

          try {
            const params = new URLSearchParams(new URL(url).search);
            filename = params
              .get("response-content-disposition")
              .split("filename=")[1];
          } catch (error) {}

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        }
      };
      xhr.send();
    },
    changeSel(val, name, arr = this.dataCenter) {
      if (name === "onLineStatus" && val === "OFFLINE")
        this.dataForm.alarmStatus = ""; 
      this.selItems = this.handleSelItem(val, name, arr);
      this.getLists(1);
    },
    init() {
      this.$store.state.spinShow = true;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.getLists();
      this.timer = setInterval(() => {
        this.getLists();
      }, 1000 * 60);
      let item = this.sockedlist.find((e) => e.type == "gateway");
      this.soikobj = item;
      this.timernum = item.totalTime * (1000 * 60);

      let dataColumn = this.dataColumn;
      if (this.userRole.includes("c")) {
        let findIndex = dataColumn.findIndex((e) => e.title == "所属客户");
        this.dataColumn.splice(findIndex, 1);
      }
      let userRole = this.userRole;
      this.dataColumn = this.dataColumn.map((e) => {
        if (userRole.includes("c0")) {
          if (e.title == "操作") {
            e.width = 250;
          }
        }
        return e;
      });
    },
    navtoproedit(row) {
      this.$router.push(`/knowledge/productEdit?id=${row.id}`);
    },
    async gatedistri(row) {
      try {
        let { data } = await olistiePage(row.id); //全部驱动
        let datas = data;
        const { driverId, driverName, gatewayDriverId } =
          datas.oilSiteGatewayDetailDriverVO;
        let obj = {
          gatewayId: datas.id,
          deplyType: "deploy",
          driverId,
          driverName,
          edgeInstanceId: datas.edgeInstanceId,
        };

        let productdata = await configThingModel(obj);

        if (productdata.code == "00000") {
          this.$Message.success("操作成功");
        } else {
          this.$Message.info(productdata.msg);
        }
        this.$store.state.spinShow = false;
      } catch (error) {}
    },
    async electmeter(row) {
      this.$store.state.spinShow = true;
      try {
        let { data } = await olistiePage(row.id); //全部驱动
        let datas = data;

        const { driverId, driverName, gatewayDriverId } =
          datas.oilSiteGatewayDetailDriverVO;
        let obj = {
          driverId,
          driverName,
          edgeInstanceId: datas.edgeInstanceId,
          gatewayDriverId,
          gatewayId: datas.id,
          gatewayName: datas.nickName,
          id: datas.productId === null ? "" : datas.productId,
        };

        let productdata = await excelup(obj);

        if (productdata.code == "00000") {
          this.$Message.success("操作成功");
        } else {
          this.$Message.info(productdata.msg);
        }
        this.$store.state.spinShow = false;
      } catch (error) {
        this.$store.state.spinShow = false;
      }
    },
    rowclickmethd(indx, status) {
      if (status) {
        this.dkindex = status;
      }
    },
    expand(indx, status) {
      //  if(status){
      //   this.dkindex=this.dataLists.findIndex(ele=>ele.id==indx)
      //  }
    },
    async getLists(page) {
      if (page) this.pageInfo.current = page; //分页处理
      let res = await gatewayAllData({ ...this.pageInfo, ...this.dataForm });

      if (res.code === "00000") {
        const datas = res.data;
        let records = datas.records;
        // if(records.length>0){
        //   let item=records[0]
        //   if(item.groupAuthorityString=="r"){
        //     let findIndex=this.dataColumn.findIndex(e=>e.title=="操作")
        //     if(findIndex>-1){
        //       this.dataColumn.splice(findIndex,1)
        //     }
        //   }
        // }
        console.log("records", records);
        let strarray = [];
        this.dataLists = datas.records.map((item, index) => {
          if (
              item.oilSiteGatewayDetailOilSiteVOList &&
              item.oilSiteGatewayDetailOilSiteVOList.length > 0
            ) {
             strarray.push(item.oilSiteGatewayDetailOilSiteVOList[0].oilSiteName);
            }
         
         
         if (index == this.dkindex) {
            item._showChildren = true;
          } else {
            item._showChildren = false;
          }
          return item;
        });
    console.log('strarray',strarray)
    let longestString = strarray.reduce((a, b) => a.length > b.length ? a : b, '');
    let width=longestString.length*15;
     if(width>300){
      this.dataColumn = this.dataColumn.map((e) => {
          if (e.title == "关联润滑点") {
            e.width = width;
          }
        return e;
      });
     }
        this.pageInfo.total = datas.total;
      }
      this.$store.state.spinShow = false;
    },
    getListsSize(size) {
      this.pageInfo.size = size;
      this.getLists(1);
    },
    searchInput(val, name) {
      this.selItems = this.handleSelItem(val, name);
      this.getLists(1);
    },
    changeDate(date, name) {
      this.dataForm.activeStart = date[0];
      this.dataForm.activeEnd = date[1];
      this.selItems = this.handleSelItem(date[0] + "至" + date[1], name);
      this.getLists(1);
    },
    delSelItem(selItem, index) {
      this.dataForm[selItem.name] = null;
      //日期需要单独处理
      if (selItem.name === "date") {
        delete this.dataForm.activeStart;
        delete this.dataForm.activeEnd;
      }

      this.selItems.splice(index, 1);
      this.getLists(1);
    },
    addEquip() {
      this.curItemDetail = {}; // 重置form
      this.showDrawer = true;
    },
    // 获取全部驱动
    getAllDriver: async function () {
      let data = await allDriver(); //全部驱动
      this.dataTypeOption = data.data;
    },
    addEquipType(item) {
      this.curItemDetail = deepcopy(item);
      this.curItemDetail.name = ""; // 重置类名(后端设置的大类名称和类型名称相同)
      this.showtypeDrawer = true;
    },
    async editDetailType(item) {
      let redata = await relatedInfo({
        id: item.id,
        type: this.soikobj.type,
        chinaType: this.soikobj.typeName,
      });
      if (redata.data) {
        this.showtypeDrawer = true;
        this.curItemDetail = deepcopy({
          ...item,
        });
      } else {
        this.$Message.info(redata.msg);
      }
    },
    delItemWarning(item) {
      // if (item.statu === "ONLINE") return;
      let curItemDetail = deepcopy(item);

      const { id, nodeId, sn } = curItemDetail;
      let title = "";
      let content = `网关名称：${item.nickName}`;
      let oilSiteGatewayDetailOilSiteVOList =
        item.oilSiteGatewayDetailOilSiteVOList;
      console.log(
        "oilSiteGatewayDetailOilSiteVOList",
        oilSiteGatewayDetailOilSiteVOList
      );
      if (!oilSiteGatewayDetailOilSiteVOList) {
        oilSiteGatewayDetailOilSiteVOList = [];
      }
      if (oilSiteGatewayDetailOilSiteVOList.length == 0) {
        title = "请确认是否删除该网关？";
      } else {
        title = "此网关已经关联了润滑点，请确认是否删除该网关";
      }

      if (item.statu !== "ONLINE") {
        title = " 离线网关删除后可能无法正常配置，请确认是否删除该网关？";
      }
      console.log("title", title);
      this.$Modal.confirm({
        render: (h, params) => {
          return (
            <div style=" position: relative;left:-10px">
              <div class="ivu-modal-confirm-head u-flex">
                <div class="ivu-modal-confirm-head-icon ivu-modal-confirm-head-icon-confirm">
                  <Icon type="ios-help-circle" />
                </div>
                <div
                  style="white-space: nowrap;"
                  class="ivu-modal-confirm-head-title"
                >
                  {title}
                </div>
              </div>
              <div class="ivu-modal-confirm-body">
                <div>{content}</div>
              </div>
            </div>
          );
        },
        // title: title,
        // content,
        width: "500px",
        onOk: () => {
          this.delItem({ id });
        },
        onCancel: () => {},
      });
    },
    delItem(formdate) {
      api.axss("POST", `/ocm-oil-site/gateway/del`, formdate).then((res) => {
        if (res.code === "00000") {
          this.$Message.success("删除成功");
          this.curItemDetail = {};
          const finalSize = this.sizeData(
            this.pageInfo.size,
            this.pageInfo.current,
            this.pageInfo.total
          );
          this.getLists(finalSize);
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    closeDrawer(index = 1) {
      console.log("111111111", index);
      if (index == 0) {
        sockedDel({
          id: this.curItemDetail.id,
          type: this.soikobj.type,
        });
      }
      this.showDrawer = false;
      this.showtypeDrawer = false;
      this.curItemDetail = {};
    },
    resetData() {
      this.reset("dataForm");
      this.getLists(1);
    },
    reset(key) {
      this.selItems = [];
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
};
</script>

<style lang='less' scoped>
.knowledge-equiptype {
  .lists {
    margin-top: 20px;
  }
}
</style>